import React, { useState } from 'react';
import GlobalHeader from './GlobalHeader';

const PageLayout = ({ 
  children, 
  showRefreshButton = true,
  customRefreshFunction = null,
  showHeader = true,  // Novo parâmetro para controlar se deve mostrar o header
  rootClassName = 'theme-bg',
  mainClassName = ''
}) => {
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(new Date());
  const [loading, setLoading] = useState(false);

  // Função padrão de atualização
  const handleRefresh = async () => {
    setLoading(true);
    try {
      // Simular atualização
      await new Promise(resolve => setTimeout(resolve, 1000));
      setUltimaAtualizacao(new Date());
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Se houver função customizada, executar ela e também atualizar o timestamp (comportamento do botão superior)
  const atualizarDados = customRefreshFunction
    ? async () => {
        setLoading(true);
        try {
          await customRefreshFunction();
          setUltimaAtualizacao(new Date());
        } finally {
          setLoading(false);
        }
      }
    : handleRefresh;

  return (
    <div className={`min-h-screen w-full max-w-full overflow-x-hidden ${rootClassName}`}>
      {showHeader && (
        <GlobalHeader 
          ultimaAtualizacao={ultimaAtualizacao}
          loading={loading}
          atualizarDados={atualizarDados}
          showRefreshButton={showRefreshButton}
        />
      )}
      
      <main
        id="main-content"
        tabIndex="-1"
        className={`flex-1 w-full max-w-full overflow-x-hidden focus:outline-none ${mainClassName}`}
      >
        {children}
      </main>
    </div>
  );
};

export default PageLayout;
